import { apiClient } from '@/api/client';
import type { MailStatistics } from '@/features/statistics/types';

/** Aggregated mail statistics — existing mail-admin-service /statistics endpoint. */
export const statisticsApi = {
  overview: async (windowHours: number): Promise<MailStatistics> =>
    (await apiClient.get<MailStatistics>('/statistics', { params: { windowHours } })).data,
};
